export enum CardProvider {
  WEAVR = 'WEAVR',
  AIRWALLEX = 'AIRWALLEX',
}
